export default __webpack_public_path__ + "static/media/newsletter.c9bf80c4.svg";